var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStarHalf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.621l-7.19-0.653-2.81-6.968-2.81 6.979-7.19 0.642 5.46 4.979-1.64 7.4 6.18-3.926 6.18 3.926-1.63-7.4zM12 16.105v-9.789l1.71 4.253 4.38 0.4-3.32 3.031 1 4.505z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarHalf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star-half.262fb864.svg";
export { ForwardRef as ReactComponent };